import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';

@Component
export default class BasicFormValidator extends Vue {
  private errors = {
    firstName: '',
    lastName: '',
    password: '',
    phone: '',
    email: '',
    confirmPassword: '',
  };
  private confirmPassword = '';

  confirmPasswordChange(value) {
    this.confirmPassword = value;
  }

  validateBasicForm(values) {
    this.errors = {
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
    };
    //const inputformat = /^([a-zA-z0-9'-. ,]+)$/;
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const hasNumber = values.password.match(/\d+/g);
    const hasLetter = values.password.match(/[a-zA-Z]/g);
    const hasUpperCase = values.password.match(/[A-Z]/g);
    const hasSpecialCharacter = values.password.match(/[*@!#%&()^~{}]+/g);

    let isValid: boolean = true;
    if (!values.email.match(emailformat)) {
      this.errors.email = 'signup.enter.valid.email';
    }
    if (!values.email) {
      this.errors.email = 'signup.email.required';
    }
    if (
      values.password.length <
        vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH') ||
      (hasNumber == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS')) ||
      hasLetter == null ||
      (hasUpperCase == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS')) ||
      (hasSpecialCharacter == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS'))
    ) {
      this.errors.password = vxm.utility.passwordConditions;
    }
    if (!values.password) {
      this.errors.password = 'signup.password.required';
    }
    if (values.password !== this.confirmPassword) {
      this.errors.confirmPassword = 'signup.password.confirmation.equivalent';
    }
    if (!values.firstName) {
      this.errors.firstName = 'signup.firstname.required';
    }
    if (!values.lastName) {
      this.errors.lastName = 'signup.lastname.required';
    }
    if (!values.phoneNumberValid) {
      this.errors.phone = 'signup.phone.valid';
    }
    if (!values.phone) {
      this.errors.phone = 'signup.phone.required';
    }
    Object.keys(this.errors).forEach((key) => {
      isValid = isValid && !this.errors[key];
    });
    return isValid;
  }
  

}
